export enum CLIENT_DASHBOARD_TABS {
  PROFILE = "myCleaningsProfileTab",
  OPTION = "myCleaningsOptionsTab",
  MY_CLEANINGS = "myCleaningsTab",
  BOOKINGS_TO_VALIDATE = "bookingsToValidate",
  MY_LAUNDRY = "myLaundry",
}

export enum CLIENT_DASHBOARD_MOBILE {
  PROFILE = "myCleaningsProfileMobile",
  MY_CLEANINGS = "myCleaningsMobile",
}
